export default __webpack_public_path__ + "static/media/wind_spritesheet.44f83c9d.png";